import './CatalogProgramPage.css';

import React, {useEffect, useLayoutEffect, useReducer, useRef} from 'react';
import axios from 'axios'; 
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import Fade from '@material-ui/core/Fade';
import Select from '@material-ui/core/Select'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faHeartbeat, faMoneyBillAlt, faLaptop, faTractor, faToolbox, faPaintBrush, faUniversity, faGraduationCap, faHandHoldingUsd, faAward, faArrowRight, faKey} from '@fortawesome/free-solid-svg-icons';
import {faMicroscope} from '@fortawesome/free-solid-svg-icons';
import {faUsers} from '@fortawesome/free-solid-svg-icons';
import SearchIcon from '@material-ui/icons/Search';
import {MenuItem, InputLabel, FormControl, Collapse, CircularProgress, LinearProgress } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Chip from '@material-ui/core/Chip';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import {alpha, makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar'; 
import Input from '@material-ui/core/Input';
import TextField from '@material-ui/core/TextField';
import Fab from '@material-ui/core/Fab';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Zoom from '@material-ui/core/Zoom';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import PropTypes from 'prop-types';
import props from 'prop-types';
import LazyLoad from 'react-lazyload';


const useStyles = makeStyles(theme => ({
  palette:{
    primary:{
      main:'#005cab',
    }
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  }, 
  formControl: {
    margin: theme.spacing(1),
    minWidth: 145,
   
  },
  formControlMobile: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width:140,
   
  },
  formControlSwitch: {
    margin: theme.spacing(2),

  },
  label:{
    color:'#777',
  },
  searchBox:{
    marginTop:0,
    marginRight: 0,
    marginLeft:20, 
    marginBottom: 14  },
  root: {
    display: 'flex',
  },
  paper: {
    right: 30,
    margin:8,
    padding:theme.spacing(2),
  },
  filters:{
    marginLeft:70,
  },
  grid: {
    flexGrow:1, 
    justifyContent:'center',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
    height:15,
    color:'#fff',
    backgroundColor:'#005cab',
  },
  gridItem:{paddingTop:4,},

  dropdown:{'&:before':{borderBottom:0,}},

  programsDropdown:{color:'white', marginBottom:26, '&:before': {borderColor: 'white !important',},'&:after': {borderColor: 'white !important',},
   
  },

  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },   
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 'auto',
    },
  },

  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    width: '100%',
  },
  button:{
    paddingTop:26,
    marginLeft:theme.spacing(1),
    '& button':{
      '& focus':{
        background:'#D6F1FA',
      }
    }
  }, 
  cardActions:{
    paddingTop:0,
  },
  pdf:{
    color:"#fff",
    marginBottom:20,
    '&:hover': {
      color:"#ccc",
      background: 'transparent',
   },
  },
  mobileDiv:{
    flexGrow: 1,
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  mobilePdf:{
    color:"#fff",

    margin:6,
    '&:hover': {
      color:"#ccc",
      background: "transparent",
   },
  }, 
  mobileSearch:{
    width: 180,
    marginLeft: 24,
    marginRight: 8,
    marginTop: 8,
  },
  mobileClear:{
    marginLeft: 8,
    paddingTop: 18,
  },
  scrollButton:{
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: 9,
   
  },
  cluster: {
    display:'flex',
    color: '#aaa',
    fontSize: '.8rem',
    width: 'fit-content',  
  },
  indicator:{
    marginRight: 3,
    color:'#727272',
    padding: '0 4px',
    fontFamily:'Open Sans',
  },

  pathwaysh3:{
    margin: '0.1em !important',
    fontSize:'1.1rem',
    
  }, 
  loadingFeedback:{
    display:'flex', 
    flexWrap:'wrap', 
    justifyContent: 'center',
    padding:15,
  
  },
  visualKey:{
    // display:'flex', 
    // flexWrap:'wrap', 
    // justifyContent: 'center',
    position:'fixed',
    right:0,
    zIndex:9,

  }, 
  vkExpanded:{
    position:'fixed',
    right:0,
    background: '#fff',
    padding: '0 30px 22px 0px',
    maxContent: 'fit-content',
    maxHeight: 'fit-content',
    boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
    margin:'0',
  }

}));

const stateMachine = (state, action) => {

  switch(action.type){
    case 'initPrograms': 
      return {...state, isLoaded:true, programs: action.payload, programArray:action.payload}

    case 'filter':
      return {...state, programArray:action.programs, filteredArray:action.programs, chipData:action.chipData, tags:action.tags}

    case 'chip':
      return {...state, chipData:action.chipData, tags:action.tags}

    case 'updatePrograms':
      return {...state, programArray:action.programs}
      
    case 'updateTags':
      return {...state, tags:action.tags}

    case 'degree':
      return {...state, degreeTags:action.tags, degreesSelected:action.degreesSelected}

    case 'endorsements':
      return {...state, tags:action.tags, endorsementSelected:action.endorsementSelected}

    case 'clear':
      return {...state, degreeTags:[], tags:[], financeTags:[],  chipData:action.chipData, searchVal:'', endorsementSelected:[], degreesSelected:[], financeSelected:[] }

    case 'finance':
      return {...state, financeTags:action.tags, financeSelected:action.financeSelected}

    case 'search': 
      return {...state, searchVal:action.searchVal}  

    
      case 'switchView': 
      return {...state, checkedView:action.payload}

      case 'mobileMenu': 
      return {...state, mobileOpen:true, categoryAnchorEL:action.anchor}

      case 'mobileClose': 
        return {...state, mobileOpen:false}

      case 'toggleDrawer':
        return {...state}



      default:return state;
  }

}


const ProgramWide = ({list}) => {

  return  list.map( (program) => 
 <li key= {'li'+program.ID}> <LazyLoad  height={220} offset={100}><ProgramListView key={'item'+program.ID} {...program}/></LazyLoad></li>
  ) ;
  
 }

const ProgramList = ({list}) => {

  return  list.map( (program) => <li key= {'li'+program.ID} ><LazyLoad  height={'100%'} offset={3200} key= {program.ID}><ProgramCard key={'card'+program.ID} {...program}/></LazyLoad></li> )  ;
   
 }

function ProgramListView(props){
  const classes = useStyles();
  
  
  


  return (

    <Fade in={true} style = {{transitionDelay : "170ms"}}>
    <Card square={true} className="cardListView">

    <CardActionArea component="a" href={props.LandingPage}>
      <CardContent>
          <Typography gutterBottom variant="h5" component="h2"> 
        {props.Program}
          </Typography>
         
          <Typography className={classes.cluster} component='p'>
            
              {(props.Cluster.includes('AFNR')) && <span title="Agriculture, Food, and Natural Resources" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faTractor}/></span>}    
              {(props.Cluster.includes('AC')) && <span title="Art and Communication" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faPaintBrush}/></span>}
              {(props.Cluster.includes('FBS')) && <span title="Finance and Business" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faMoneyBillAlt}/></span>}
              {(props.Cluster.includes('HST')) && <span title="Health Sciences and Technology" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faHeartbeat}/></span>}
              {(props.Cluster.includes('HPS')) && <span title="Human and Public Services" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faUsers}/></span>}
              {(props.Cluster.includes('IT')) && <span title="Information Technology" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faLaptop}/></span> }
              {(props.Cluster.includes('METT')) && <span title="Manufacturing, Engineering, Technology and Trades" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faToolbox}/></span>   } 
              {(props.Cluster.includes('LA')) && <span title="Liberal Arts" className={classes.indicator}><FontAwesomeIcon   color="default" icon={faUniversity}/></span>}
              {(props.Cluster.includes('SM')) && <span title="Science and Mathematics" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faMicroscope}/></span>}
              {(props.Cluster.includes('AA')) && <span title="Associate in Arts" className={classes.indicator}><FontAwesomeIcon   color="default" icon={faGraduationCap}/>&nbsp;AA</span>}
              {(props.Cluster.includes('AS')) && <span title="Associate in Science" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faGraduationCap}/>&nbsp;AS</span>}
              {(props.Cluster.includes('AAS')) && <span title="Associates in Applied Science" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faGraduationCap}/>&nbsp;AAS</span>}
              {(props.Cluster.includes('AES')) && <span title="Associate in Engineering Science" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faGraduationCap}/>&nbsp;AES</span>}
              {(props.Cluster.includes('CERT')) && <span title="Certificate" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faAward}/>&nbsp;CERT</span>}
              {(props.Cluster.includes('MICRO')) && <span title="Microcertificate" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faAward}/>&nbsp;MICRO</span>}
              {(props.Cluster.includes('FA')) && <span title="Financial Aid" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faHandHoldingUsd}/>&nbsp;FA</span>}
              {(props.Cluster.includes('WRS')) && <span title="Work Ready Scholarship" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faHandHoldingUsd}/>&nbsp;WRS</span>}
         
          </Typography>
          <Typography className={classes.description}  component="p">
           {props.Description}
          </Typography>
        </CardContent>
       
      </CardActionArea>
        <CardActions className={classes.cardActions}>{ 
        (props.CourseDescriptionURL) &&
          <Button  href={(props.CourseDescriptionURL)} size="small" color="primary">
            <Icon>library_books</Icon><span className="visually-hidden">{props.Program}</span> Courses </Button>
        } 
        </CardActions>
      </Card>
    </Fade>

  )
}

function ProgramCard(props){
  const classes = useStyles(); 

  const [pathExpand, setPathExpand] = React.useState(false);
  const [pathway, setPathway] = React.useState([]); 
  const [jobsExpand, setJobsExpand] = React.useState(false); 
  const [degreePathwayFeatureToggle, setDegreePathwayFeatureToggle] = React.useState(false); 



 
  const fetchPathway = async (program) => {
    try{
    
      const result = await axios({ 
  
        method:'get',  
  
        headers:{'Content-Type':'application/json',  
  
        'X-DreamFactory-Api-Key':'0e009b47183e63c92dbc01727bdd6882bf237eac47fa6c101b5eae28ece00250'},  
  
        crossDomain: true,  
  
        url:'https://dfprd.heartland.edu/api/v2/k2_smartboxdata/_table/IT_Pathways?filter=(Program='+program+')&order=Degree DESC'   
  
      });   
  
      if(result.data.resource.length !== 0){
        setPathway(result.data.resource); 
      }
      else {
      
        const empty = []; 
        setPathway(empty); 
       
      }
    } catch(error){
      console.log(error); 
      const result = await axios.get('pathways.json'); 
      setPathway(result.data.resource); 
    }
  
  
   }



  const togglePath = (program) => () => {


    setPathExpand(!pathExpand);
    
    if(!pathExpand){
  
    fetchPathway(program); 

      
  
    } else{
      
    }

  
    
  };


  return (
    
    <Fade in={true} style = {{transitionDelay : "170ms"}}>
  
    <Card square={true} className="card">

    <CardActionArea component="a" href={props.LandingPage}>
   

   { (props.ImageURL) &&  <picture> 
     <source srcSet={props.ImageURL} type="image/webp" /> 
     <img src={  props.FallbackImageURL  } alt="" className="media"/>
     </picture>
    } <CardContent>
          <Typography gutterBottom variant="h5" component="h2"> 
        {props.Program}
          </Typography>
        
          <Typography className={classes.cluster} component='div'>

              
          {(props.Cluster.includes('AFNR')) && <span><span  aria-hidden="true" title="Agriculture, Food, and Natural Resources" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faTractor}/></span><span className='visually-hidden'>Agriculture, Food, and Natural Resources</span></span>}    
              {(props.Cluster.includes('AC')) && <span><span aria-hidden="true"  title="Art and Communication" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faPaintBrush}/></span> <span className='visually-hidden'>Art and Communication</span> </span>}
              {(props.Cluster.includes('FBS')) && <span><span aria-hidden="true"  title="Finance and Business" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faMoneyBillAlt}/></span><span className='visually-hidden'>Finance and Business</span></span>}
              {(props.Cluster.includes('HST')) && <span><span  aria-hidden="true" title="Health Sciences and Technology"  className={classes.indicator}><FontAwesomeIcon color="default" icon={faHeartbeat}/></span><span className='visually-hidden'>Health Sciences and Technology</span></span>}
              {(props.Cluster.includes('HPS')) && <span><span  aria-hidden="true" title="Human and Public Services"  className={classes.indicator}><FontAwesomeIcon color="default" icon={faUsers}/></span><span className='visually-hidden'>Human and Public Services</span></span>}
              {(props.Cluster.includes('IT')) && <span> <span  aria-hidden="true" title="Information Technology" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faLaptop}/></span><span className='visually-hidden'>Information Technology </span></span>  }
              {(props.Cluster.includes('METT')) && <span><span  aria-hidden="true" title="Manufacturing, Engineering, Technology and Trades" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faToolbox}/></span> <span className='visually-hidden'>Manufacturing, Engineering, Technology and Trades</span></span>  } 
              {(props.Cluster.includes('LA')) && <span><span  aria-hidden="true" title="Liberal Arts" className={classes.indicator}><FontAwesomeIcon   color="default" icon={faUniversity}/></span><span className='visually-hidden'>Liberal Arts</span></span>}
              {(props.Cluster.includes('SM')) && <span> <span  aria-hidden="true" title="Science and Mathematics" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faMicroscope}/></span><span className='visually-hidden'>Science and Mathematics</span></span>}
              {(props.Cluster.includes('AA')) && <span><span  aria-hidden="true" title="Associate in Arts" className={classes.indicator}><FontAwesomeIcon    color="default" icon={faGraduationCap}/>&nbsp;AA</span><span className='visually-hidden'>Associate in Arts</span></span>}
              {(props.Cluster.includes('AS')) &&  <span> <span  aria-hidden="true" title="Associate in Science" className={classes.indicator}><FontAwesomeIcon   color="default" icon={faGraduationCap}/>&nbsp;AS</span><span className='visually-hidden'>Associate in Science</span></span>}
              {(props.Cluster.includes('AAS')) &&  <span> <span aria-hidden="true"  title="Associates in Applied Science" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faGraduationCap}/>&nbsp;AAS</span><span className='visually-hidden'>Associates in Applied Science</span></span>}
              {(props.Cluster.includes('AES')) && <span><span  aria-hidden="true" title="Associate in Engineering Science" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faGraduationCap}/>&nbsp;AES</span><span className='visually-hidden'>Associate in Engineering Science</span></span>}
              {(props.Cluster.includes('CERT')) && <span><span  aria-hidden="true"  title="Certificate" className={classes.indicator}><FontAwesomeIcon   color="default" icon={faAward}/>&nbsp;CERT</span><span className='visually-hidden'>Certificate</span></span>}
              {(props.Cluster.includes('MICRO')) && <span><span  aria-hidden="true" title="Microcertificate" className={classes.indicator}><FontAwesomeIcon  color="default" icon={faAward}/>&nbsp;MICRO</span><span className='visually-hidden'>Microcertificate</span></span>}
              {(props.Cluster.includes('FA')) && <span><span  aria-hidden="true" title="Financial Aid" className={classes.indicator}><FontAwesomeIcon   color="default" icon={faHandHoldingUsd}/>&nbsp;FA</span><span className='visually-hidden'>Financial Aid</span></span>}
              {(props.Cluster.includes('WRS')) && <span><span  aria-hidden="true"  title="Work Ready Scholarship" className={classes.indicator}><FontAwesomeIcon   color="default" icon={faHandHoldingUsd}/>&nbsp;WRS</span><span className='visually-hidden'>Work Ready Scholarship</span></span>}
         

          </Typography>
          <Typography className={classes.description} component="p">
           {props.Description}
          </Typography>
        </CardContent>
       
      </CardActionArea>
      <CardActions>

      { (degreePathwayFeatureToggle) &&
      <Button onClick={togglePath(props.Program)} size="small" color="primary" aria-expanded={pathExpand}
      aria-label="Pathway">
      <Icon>school</Icon>&nbsp;Degree Pathway
        </Button>
        }
        { /*
      <Button onClick={toggleJobs()} size="small" color="primary">
      <Icon>library_books</Icon>&nbsp;Jobs 
        </Button> */}

       { (props.CourseDescriptionURL) &&
      <Button href={props.CourseDescriptionURL} size="small" color="primary">
      <Icon>library_books</Icon><span className="visually-hidden">{props.Program}</span>&nbsp;Courses 
        </Button>}

      

   


 {/* (props.Plan) &&
        <Button  href={props.Plan} size="small" color="primary">
        <Icon>assignment_turned_in</Icon> Pathway
        </Button>*/
        }
        { /*(props.ProgramCode) &&
        <Button  href={"/catalog/facultyDirectory/?subject="+ props.ProgramCode.toUpperCase()} size="small" color="primary">
        <Icon>person</Icon> Faculty
        </Button>*/
}
      { /*(props.Contact) &&
      
      <Button title="Opens mail client" href={"mailto:"+ props.Contact} size="small" color="primary">
      <Icon>mail</Icon> Contact
      </Button>*/}
       
      </CardActions>
      <Collapse in={pathExpand} timeout="auto" unmountOnExit>
     
     
      { 
        (pathway && pathway.length > 0) ? 
       
        pathway.map(path => {
          return <div key={path.Program} className="pathway-list">
        {(path.MCert1) && 
        <ul>
          <h3 className={classes.pathwaysh3}><FontAwesomeIcon  color="default" icon={faArrowRight}/>&nbsp;Stackable Microcertificates</h3>
          {(path.MCert1) && <li><a href="https://www.heartland.edu/businessTech/6153.html" target='_blank' rel='noopener, noreferrer'>{path.MCert1}</a></li>}
          {(path.MCert2) && <li><a href="https://www.heartland.edu/businessTech/6153.html" target='_blank' rel='noopener, noreferrer'>{path.MCert2}</a></li>}
          {(path.MCert3) && <li><a href="https://www.heartland.edu/businessTech/6153.html" target='_blank' rel='noopener, noreferrer'>{path.MCert3}</a></li>}
          {(path.MCert4) &&<li><a href="https://www.heartland.edu/businessTech/6153.html" target='_blank' rel='noopener, noreferrer'>{path.MCert4}</a></li>}
          {(path.MCert5) &&< li><a href="https://www.heartland.edu/businessTech/6153.html" target='_blank' rel='noopener, noreferrer'>{path.MCert5}</a></li>}
        </ul>}
        
        {(path.Cert1) && <ul>
        <h3 className={classes.pathwaysh3}> <FontAwesomeIcon  color="default" icon={faArrowRight}/>&nbsp;Stackable Certificates</h3>
        {(path.Cert1) && <li><a href="https://www.heartland.edu/accounting/6165.html" target='_blank' rel='noopener, noreferrer'> {path.Cert1} </a></li>}
        {(path.Cert2) && <li><a href="https://www.heartland.edu/businessTech/6140.html" target='_blank' rel='noopener, noreferrer'> {path.Cert2}</a></li>}
        {(path.Cert3) && <li><a href="https://www.heartland.edu/businessTech/6155.html" target='_blank' rel='noopener, noreferrer'> {path.Cert3}</a></li>}
        {(path.Cert4) && <li><a href="https://www.heartland.edu/businessTech/6155.html" target='_blank' rel='noopener, noreferrer'> {path.Cert4}</a></li>}
        {(path.Cert5) && <li><a href="https://www.heartland.edu/businessTech/6155.html" target='_blank' rel='noopener, noreferrer'> {path.Cert5}</a></li>}
        </ul>}
          
        {(path.Degree) &&  
        <ul><h3 className={classes.pathwaysh3}><FontAwesomeIcon  color="default" icon={faArrowRight}/>&nbsp;Stackable Degrees</h3>
        {(path.Degree) && <li><a href="https://www.heartland.edu/businessTech/5121.html" target='_blank' rel='noopener, noreferrer'> {path.Degree} </a></li>}
        {(path.Degree2) &&  <li><a href="https://www.heartland.edu/businessTech/5121.html" target='_blank' rel='noopener, noreferrer'>{path.Degree2}</a></li>}
        {(path.Degree3) && <li><a href="https://www.heartland.edu/businessTech/5121.html" target='_blank' rel='noopener, noreferrer'> {path.Degree3}</a></li>}
        </ul>}

        </div>
        }):
        <div> <LinearProgress/></div>
      }


      </Collapse>

      <Collapse in={jobsExpand} timeout="auto" unmountOnExit>
    




    <div className="cc-card"> 

      <div className="cc-content"> 

      <div id="cc-widget-careers"></div> 

    </div> 

    </div>
  
      </Collapse>
    </Card></Fade>
  );


}


function ScrollTop(props) {
  const { children } = props;
  const classes = useStyles();

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100,
  });

  const handleScroll = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector('#back-to-top-anchor');

    if (anchor) {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleScroll} role="presentation" className={classes.scrollButton}>
        {children}
      </div>
    </Zoom>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
};

function CatalogIndex(){
 const classes = useStyles(); 

 const [state, dispatch] = useReducer(stateMachine, {
      error: null, 
      isLoaded: false, 
      department: '', 
      programs: [],
      programArray : [],
      tabVal: 0,
      filteredArray: [],
      view: ['card', 'list'], 
      currentView: 'list', 
      checkedView: true,
      degreeVal:'', 
      financeVal:'',
      
      categoryAnchorEL:null, 
      mobileOpen: false,
      mobileProgramsOpen:false,
      moreOpen: false, 
      moreAnchorEl: null,
      chipOn:false,
      drawerOpen:false,
      tags:[],
      degreeTags:[],
      financeTags:[],
      searchVal:'',
      mobileProgramFilter:'All',
      chipData: [  
        { key: 0, avatar:<Avatar color='default'><FontAwesomeIcon icon={ faTractor}/></Avatar>, label:'Agriculture, Food and Natural Resources', value:'AFNR', color:'default', chipOn:false},
        { key: 1, avatar:<Avatar color='default'> <FontAwesomeIcon icon={faPaintBrush} /></Avatar>, label:'Art and Communication', value:'AC', color:'default', chipOn:false},
        { key: 2, avatar: <Avatar color='default'><FontAwesomeIcon icon={faMoneyBillAlt} /></Avatar>, label:'Finance and Business', value:'FBS', color:'default', chipOn:false },
        { key: 3, avatar: <Avatar color='default'><FontAwesomeIcon icon={faUsers} /></Avatar>, label:'Human and Public Services', value:'HPS', color:'default', chipOn:false },
        { key: 4, avatar: <Avatar color='default'><FontAwesomeIcon icon={faHeartbeat} /></Avatar>, label:'Health Sciences and Technology', value:'HST', color:'default', chipOn:false },
        { key: 5, avatar: <Avatar color='default'><FontAwesomeIcon icon={faLaptop} /></Avatar>, label:'Information Technology', value:'IT', color:'default', chipOn:false },
        { key: 6, avatar: <Avatar color='default'><FontAwesomeIcon icon={faToolbox} /></Avatar>, label:'Manufacturing, Engineering, Technology and Trades', value:'METT', color:'default', chipOn:false },
        { key: 7, avatar: <Avatar color='default'><FontAwesomeIcon icon={faUniversity} /></Avatar>, label:'Liberal Arts', value:'LA', color:'default', chipOn:false },
        { key: 8, avatar: <Avatar color='default'><FontAwesomeIcon icon={faMicroscope} /></Avatar>, label:'Science and Mathematics', value:'SM', color:'default', chipOn:false },
      ],
      endorsements:[
        {value:'AFNR', name: 'Agriculture, Food and Natural Resources'},
        {value:'AC', name: 'Art and Communication'},
        {value:'FBS', name: 'Finance and Business Services'},
        {value:'HPS', name:'Human and Public Services'},
        {value:'HST', name: 'Health Sciences and Technology'},
        {value:'IT', name: 'Information Technology'},
        {value:'METT', name: 'Manufacturing, Engineering, Technology and Trades'} ,
        {value:'LA', name: 'Liberal Arts'} ,
        {value:'SM', name: 'Science and Mathematics'} 
     ],
      degrees:[
        {value:'AA', name:'Associate in Arts'},
        {value:'AS', name:'Associate in Science'},
        {value:'AAS', name:'Associates in Applied Science'},
        {value:'AES', name:'Associate in Engineering Science'},
        {value:'CERT', name:'Certificates'}, 
        {value:'MICRO', name:'Microcertificates'},
      ],
      finance:[
        {value:'FA', name:'Financial Aid'},
        {value:'WRS', name:'Work Ready Scholarships'},
     
      ],
      
      degreesSelected: [],
      financeSelected: [],
      endorsementSelected:[],
      pathDrawerOpen:false, 
     

 }); 

 const allProgsRef = useRef(state.programs);
 const progsRef = useRef(state.programArray);
 const tags = useRef(state.tags); 
 const dTags = useRef(state.degreeTags); 
 const fTags = useRef(state.financeTags); 
 const searchRef = useRef(state.searchVal);
 const [vkExpand, setVkExpand] = React.useState(false);


 useLayoutEffect( () => {

  const fetchPrograms = async (filter) => {

    try{
     // const result = await axios.get('db.json');
      const result = await axios({ 

        method:'get',  

        headers:{'Content-Type':'application/json',  

        'X-DreamFactory-Api-Key':'991dc2bd1d368f625da9794c1e8d817b1a25be24d086994118d52be0ec5aa1bb'},  

        crossDomain: true,  

        url:'https://dfprd.heartland.edu/api/v2/k2_smartboxdata/_table/IT_Degrees?order=Program'  

      });   
  
      
      let degrees = JSON.parse(JSON.stringify(result.data.resource)); 


       degrees.forEach(item =>  item.Cluster = item.Cluster.split(','));


    dispatch({type:'initPrograms', payload:degrees}); 

    } catch(error){
      console.log(error); 
      const result = await axios.get('db.json');  
      
      let degrees = JSON.parse(JSON.stringify(result.data.resource)); 


      degrees.forEach(item =>  item.Cluster = item.Cluster.split(','));
      
      dispatch({type:'initPrograms', payload:result.data.resource}); 

    }
    };    
    
    fetchPrograms();


 }, []); 


 useEffect( () => {
  progsRef.current = state.programArray;
 }, [state.programArray] );

 useEffect(() =>{
  allProgsRef.current = state.programs;
 },[state.programs]);

 useEffect(() => {
  tags.current = state.tags;

  console.log(allProgsRef.current); 
  filterProgs(tags.current, dTags.current, fTags.current, searchRef.current, allProgsRef.current);
  
 }, [state.tags]);

 useEffect(() => {
  fTags.current = state.financeTags;
  filterProgs(fTags.current, tags.current, dTags.current, searchRef.current, allProgsRef.current);
  
 }, [state.financeTags]);

 useEffect(() => {
  dTags.current = state.degreeTags;
  filterProgs(dTags.current, tags.current, fTags.current, searchRef.current, allProgsRef.current);

 }, [state.degreeTags] );

 useEffect(() => {
   searchRef.current = state.searchVal; 

   filterProgs(dTags.current, tags.current, fTags.current, searchRef.current, allProgsRef.current);

 }, [state.searchVal]);

 function filterProgs(tag1, tag2, tag3, search, programs) {
 


  if(tag1.length){
    programs = programs.filter(program => Object.values(program.Cluster).some(c => tag1?.includes(c)));
  } 

  if(tag2.length){
    programs = programs.filter(program => Object.values(program.Cluster).some(c => tag2?.includes(c)));
  }

  if(tag3.length){
    programs = programs.filter(program => Object.values(program.Cluster).some(c => tag3?.includes(c)));
  }

  if(search !== '' ){
    programs = programs.filter(program => program.Program?.toLowerCase().includes(search?.toLowerCase()) || program.ProgramCode?.toLowerCase().includes(search?.toLowerCase()) || ((program.Description) && program.Description?.toLowerCase().includes(search?.toLowerCase())) );
  }

  programs =  [...new Set(programs)];

  dispatch({type:'updatePrograms', programs:programs});

 }


const matches = useMediaQuery('(max-width:768px)');
const hMatches = useMediaQuery('(min-height:600px)');

//#region Handlers  
           
  const handleSearch = event => {
 
   dispatch({type:"search", searchVal:event.target.value});
  
   }     
   

 const turnChipOn = chipToColor =>{

  chipToColor.color = 'primary'; 
  chipToColor.chipOn = true;
  return chipToColor;
}

const turnChipOff = chipToColor =>{
  chipToColor.color = 'default'; 
  chipToColor.chipOn = false;
  return chipToColor
}

const handleClick = data => {
  
  let chipData = state.chipData;
  let chipToColor = chipData[chipData.indexOf(data)];
  let tags = state.tags;

  if(!chipToColor.chipOn){

    tags.push(data.value);
    
    chipToColor = turnChipOn(chipToColor);
    chipData[chipData.indexOf(data)] = chipToColor;
    let newTags = [...new Set(tags)];
    dispatch({type:'chip', chipData:chipData, tags:newTags});

  }else {
    let newTags = tags.filter(item => item !== data.value);
    chipToColor = turnChipOff(chipToColor); 
    chipData[chipData.indexOf(data)] = chipToColor;
    dispatch({type:'chip', chipData:chipData, tags:newTags});
  }

}


const handleDegreeFilter = event => {
  let tags = state.degreeTags;
  let selectedDegreeVals = [];
  event.target.value.forEach(val => {
     selectedDegreeVals.push(val);
  });

 let diff = state.degreesSelected.filter( item => !event.target.value.includes(item) );
 
 if(diff.length){
   tags = tags.filter(item => !item.includes(diff));
 }

 event.target.value.forEach(val => {
      tags.push(val);
   });
  
  let newTags = [...new Set(tags)];
  dispatch({type:'degree', tags:newTags, degreesSelected:event.target.value});
}

const handleFinanceFilter = event => {
  let tags = state.financeTags;
  let selectedFinanceVals = [];
  event.target.value.forEach(val => {
     selectedFinanceVals.push(val);
 });

 let diff = state.financeSelected.filter( item => !event.target.value.includes(item));
 
 if(diff.length){
   tags = tags.filter(item => !item.includes(diff));
 }

 event.target.value.forEach(val => {
      tags.push(val);
   });
  
  let newTags = [...new Set(tags)];
  dispatch({type:'finance', tags:newTags, financeSelected:event.target.value});
}


 const handleMobileClose = () => {
   dispatch({type:'mobileClose'});
 }

 const handleMobileOpen = () => {
  dispatch({type:'mobileMenu'});
}

const clear = () => {

  let chipData = state.chipData.map(chip =>
    chip.chipOn === 'true'
      ?  chip
      :  { ...chip, chipOn: false, color:'default' }
  );


  dispatch({type:'clear', chipData:chipData});
}

const toggleVK = () => {
  setVkExpand(!vkExpand); 
}

//#endregion

 return(


  

   <div className={classes.grid} id="back-to-top-anchor">

    


     <ScrollTop {...props}>
        <Fab color="primary" size="small" aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
  {(matches) ||
  <Grid container spacing={2}>

   <div className={classes.filters}>

      <FormControl className={classes.formControl}>
            <Grid container alignItems="center">
              <Grid item><TextField  id="search" inputRef={searchRef.current.value} label="Search" onChange={handleSearch} value={state.searchVal} /></Grid>
              <Grid item><div style={{ position: 'absolute', top: '22px', right: '1px' }}> <SearchIcon aria-hidden='true' /> </div> </Grid>
            </Grid>
          </FormControl>
           
      <FormControl className={classes.formControl}>
        <InputLabel id="degree-label">Degree Type</InputLabel>
        <Select
          labelId="degree-label"
          id="degree"
          multiple
          value={state.degreesSelected}
          onChange={handleDegreeFilter}
          input={<Input />}
          renderValue={(selected) => (
            <div className={classes.chips}>
              {selected.map((value, index) => (
                <Chip key={value} label={value} title={ state.degrees[index].name } className={classes.chip} />
              ))}
            </div>
          )}
        >
          {state.degrees.map((d) => (
            <MenuItem key={d.value} value={d.value}>
              {d.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl className={classes.formControl}>
        <InputLabel id="finance-label">Financing</InputLabel>
        <Select
          labelId="finance-label"
          id="finance"
          multiple
          value={state.financeSelected}
          onChange={handleFinanceFilter}
          input={<Input />}
          renderValue={(selected) => (
            <div className={classes.chips}>
              {selected.map((value, index) => (
                <Chip key={value} label={value} title={ state.finance[index].name} className={classes.chip} />
              ))}
            </div>
          )}
        >
          {state.finance.map((f) => (
            <MenuItem key={f.value} value={f.value}>
              {f.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl className={classes.button}>
      <Button onClick={clear}>Clear All</Button>
    
      </FormControl>
      
  </div>

  {(hMatches) &&
  <div className={classes.visualKey}>
      <Button className={classes.keyButton} aria-expanded={vkExpand} aria-controls='visualKeyModal' onClick={toggleVK}><FontAwesomeIcon icon={faKey} />&nbsp;Key</Button>
      {vkExpand &&
      <div id="visualKeyModal" className={classes.vkExpanded}>
      <ul>
       <li><span  className={classes.indicator}><FontAwesomeIcon aria-hidden="true"   color="default" icon={faGraduationCap}/>&nbsp;AA: </span><span>Associate in Arts</span></li>
          <li> <span className={classes.indicator}><FontAwesomeIcon aria-hidden="true"  color="default" icon={faGraduationCap}/>&nbsp;AS: </span><span >Associate in Science</span></li>
           <li> <span className={classes.indicator}><FontAwesomeIcon aria-hidden="true" color="default" icon={faGraduationCap}/>&nbsp;AAS: </span><span >Associates in Applied Science</span></li>
          <li><span className={classes.indicator}><FontAwesomeIcon aria-hidden="true" color="default" icon={faGraduationCap}/>&nbsp;AES: </span><span >Associate in Engineering Science</span></li>
            <li><span className={classes.indicator}><FontAwesomeIcon  aria-hidden="true"  color="default" icon={faAward}/>&nbsp;CERT:</span><span >Certificate </span></li>
              <li><span className={classes.indicator}><FontAwesomeIcon aria-hidden="true" color="default" icon={faAward}/>&nbsp;MICRO:</span><span >Microcertificate </span></li>
       <li><span className={classes.indicator}><FontAwesomeIcon  aria-hidden="true" color="default" icon={faHandHoldingUsd}/>&nbsp;FA:</span><span >Financial Aid </span></li>
         <li><span className={classes.indicator}><FontAwesomeIcon  aria-hidden="true" color="default" icon={faHandHoldingUsd}/>&nbsp;WRS: </span><span >Work Ready Scholarship</span></li>
         </ul>
        </div>}
  </div>
  }

    </Grid>}
    
 
  {(matches) ||
  <div className="chipRoot">
  <div className="chipContainer">
      <ul>
          {state.chipData.map(data => { return <li key={"li-" + data.key }><Chip className="chip" avatar={data.avatar} clickable key={data.key} label={data.label} color={data.color} onClick={(event) => handleClick(data)}/> </li> })}
      </ul>
 
   </div>

</div>



   }

   {(matches) && 
  
<div className="mobileDiv">
   
       <div className="chipRoot">
  <div className="chipContainer">
      <ul>
          {state.chipData.map(data => { return <li key={"li-" + data.key }><Chip className="chip" avatar={data.avatar} clickable key={data.key} label={data.label} color={data.color} onClick={(event) => handleClick(data)}/> </li> })}
      </ul>
 
   </div>

</div>
<Grid></Grid>
<FormControl  className={classes.mobileSearch}>
            <Grid container alignItems="center">
              <Grid item><TextField  id="search" inputRef={searchRef.current.value} label="Search" onChange={handleSearch} value={state.searchVal} /></Grid>
              <Grid item><div style={{ position: 'absolute', top: '22px', right: '1px' }}> <SearchIcon aria-hidden='true' /> </div> </Grid>
            </Grid>
          </FormControl>  

      <FormControl className={classes.button}>
      <Button onClick={clear}>Clear All</Button>
      </FormControl>

         {/* <FormControl><Button href="https://www.heartland.edu/documents/catalog/hcccatalog.pdf" size="small" className={classes.mobilePdf} title="Catalog PDF" endIcon={<FontAwesomeIcon icon={faFilePdf} />}>
        </Button></FormControl> */}
{/*  
         <IconButton edge="end" className={classes.menuButton} color="inherit" aria-label="menu" onClick={handleMobileMenu}>
            <MoreVertIcon />
            </IconButton>               */}
      

<SwipeableDrawer anchor={'right'} open={state.mobileOpen} onClose={handleMobileClose} onOpen={handleMobileOpen}>
<FormControl className={classes.formControlMobile}>
        <InputLabel id="degree-label">Degree Type</InputLabel>
        <Select
          labelId="degree-label"
          id="degree"
          multiple
          value={state.degreesSelected}
          onChange={handleDegreeFilter}
          input={<Input />}
          renderValue={(selected) => (
            <div className={classes.chips}>
              {selected.map((value) => (
                <Chip key={value} label={value} className={classes.chip} />
              ))}
            </div>
          )}
        >
          {state.degrees.map((d) => (
            <MenuItem key={d.value} value={d.value}>
              {d.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl className={classes.formControlMobile}>
        <InputLabel id="finance-label">Financing</InputLabel>
        <Select
          labelId="finance-label"
          id="finance"
          multiple
          value={state.financeSelected}
          onChange={handleFinanceFilter}
          input={<Input />}
          renderValue={(selected) => (
            <div className={classes.chips}>
              {selected.map((value) => (
                <Chip key={value} label={value} className={classes.chip} />
              ))}
            </div>
          )}
        >
          {state.finance.map((f) => (
            <MenuItem key={f.value} value={f.value}>
              {f.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
 
</SwipeableDrawer> 
   </div>
   }
   
     {(matches) ||  
     <div className="program-list">  
      
     { (state.programs && state.programs.length > 0) ? <ul> <ProgramList list = {state.programArray} /></ul>:  <div className={classes.loadingFeedback}><CircularProgress style={{'color': '#063472'}}/></div> } 

{( (state.programArray) && (state.programArray.length === 0) && (state.programs.length > 0) ) && <div className={classes.loadingFeedback}>No degrees or certificates found.</div> }
     </div> 
   }
  {(matches) &&  
     <div className="program_listFull">            
     
     { (state.programs && state.programs.length > 0) ? <ul> <ProgramWide list = {state.programArray} /></ul>:  <div className={classes.loadingFeedback}><CircularProgress style={{'color': '#063472'}}/></div> } 

      {( (state.programArray) && (state.programArray.length === 0) && (state.programs.length > 0) ) && <div className={classes.loadingFeedback}>No degrees or certificates found.</div> }

     
     </div> 
   }
   </div>
 );
}




export default CatalogIndex;

  